package com.loyola.acessoescola.ui.addnew

import androidx.compose.ui.graphics.ImageBitmap
import com.loyola.acessoescola.data.AcessoEscolaInRecord
import com.loyola.acessoescola.data.JsonInValues

data class AddNewState(
    var recordID: String? = null,
    var email: String = "",
    var fullName: String = "",
    var cpf: String = "",
    var bound: String = Bounds.NONE.string,
    var phone: String = "",
    var photoUri: String? = null,
    var photoBitmap: ImageBitmap? = null,
    var fullNameError: Boolean = false,
    var cpfError: Boolean = false,
    var boundError: Boolean = false,
    var phoneError: Boolean = false,
    var photoError: Boolean = false,
    var saveRequested: Boolean = false
)


fun AddNewState.toJsonInValues(): JsonInValues {
    return JsonInValues(
        jsonValues = AcessoEscolaInRecord(
            recordID = recordID ?: throw RuntimeException("recordID não definido"),
            name = fullName,
            cpf = cpf,
            phone = phone,
            bound = bound,
            email = email
        )
    )
}